import React, {
  forwardRef,
  Ref, useEffect, useState,
} from 'react';
import { DropDownList } from '@ast/magma/components/dropdownlist';

export type DropDownItem = { label: string; value: string };

export interface DropDownItemsProps {
  readonly label: string,
  readonly value: string,
  readonly data: DropDownItem[];
  readonly className?: string;
  readonly onChange?: (value: string | null) => void
}

const getItemLabel = (item: DropDownItem) => item?.label;
const getItemValue = (items: DropDownItem[], value: string) => items.find((item) => {
  const currentValue = value ? value.toLowerCase() : '';
  return item.value.toLowerCase() === currentValue || item.label.toLowerCase() === currentValue;
}) || null;

export const DropDownItems = forwardRef(
  ({
    label,
    value,
    data,
    onChange,
    ...props
  }:DropDownItemsProps, ref: Ref<HTMLButtonElement>) => {
    const items: DropDownItem[] = data;

    const [currentItem, setCurrentItem] = useState<DropDownItem | null>(
      getItemValue(items, value),
    );

    useEffect(() => {
      if (onChange && currentItem) {
        onChange(currentItem.value || null);
      }
    }, [currentItem]);

    return (
      <DropDownList
        {...props}
        data-stable-name="DropDownItems"
        ref={ref}
        getItemLabel={getItemLabel}
        value={currentItem}
        data={items}
        label={label}
        onChange={setCurrentItem}
      />
    );
  },
);
